import React from "react";
import { Modal, Button, ModalTitle, ModalBody, Row, Col, Toast } from "react-bootstrap";
import ModalHeader from "react-bootstrap/ModalHeader";
import ModalButton from "./ModalButton";
import PropTypes from "prop-types";

export default class RevShareModal extends React.Component {
  render() {
    return (
      <>
        <Button
          onClick={this.handleShow}
          size={this.props.buttonSize || "sm"}
          style={{ ...this.props.buttonStyle, margin: "5px", minWidth: "70px" }}
          variant={this.props.buttonVariant || "light"}
        >
          {this.props.buttonText || "Open Modal"}
        </Button>

        <Modal backdrop="static" onHide={this.handleClose} show={this.state.show} size={this.props.modalSize || "lg"}>
          <ModalHeader>
            <ModalTitle>{this.props.title || "Modal Title"}</ModalTitle>
          </ModalHeader>
          <ModalBody>
            {this.props.children}
            <Row>
              <Col>
                {this.props.hideYesButton ? null : (
                  <ModalButton
                    api={this.props.api}
                    clicked={this.state.saving || false}
                    isSubmit
                    onClick={this.yesButtonOnClick}
                    variant={this.props.yesButtonVariant || "primary"}
                  >
                    {this.props.yesButtonText || "Submit"}
                  </ModalButton>
                )}

                <ModalButton
                  clicked={this.state.saving || false}
                  onClick={this.noButtonOnClick}
                  variant={this.props.noButtonVariant || "light"}
                >
                  {this.props.saving ? "Exit" : this.props.noButtonText || "Cancel"}
                </ModalButton>
              </Col>
            </Row>
          </ModalBody>
        </Modal>
        <div className="modal-status-toasts">
          <Toast
            autohide
            delay={3000}
            onClose={() => this.setState({ showYesButtonToast: false })}
            show={this.state.showYesButtonToast}
          >
            <Toast.Header>
              <strong className="mr-auto">{this.props.title || "Modal Alert"}</strong>
              <small>{this.state.yesButtonToastTime}</small>
            </Toast.Header>
            <Toast.Body>Request submitted.</Toast.Body>
          </Toast>
          <Toast
            autohide
            delay={3000}
            onClose={() => this.setState({ showYesButtonCompletedToast: false })}
            show={this.state.showYesButtonCompletedToast}
          >
            <Toast.Header>
              <strong className="mr-auto">{this.props.title || "Modal Alert"}</strong>
              <small>{this.state.yesButtonCompletedToastTime}</small>
            </Toast.Header>
            <Toast.Body>
              Request {this.state.yesButtonCompletedStatus ? "completed successfully" : "failed"}.
            </Toast.Body>
          </Toast>
        </div>
      </>
    );
  }

  constructor(props) {
    super(props);
    this.state = {
      show: false,
      saving: false,
      showYesButtonToast: false,
      yesButtonToastTime: null,
      showYesButtonCompletedToast: false,
      yesButtonCompletedStatus: false,
      yesButtonCompletedToastTime: null,
    };

    this.handleClose = this.handleClose.bind(this);
    this.handleShow = this.handleShow.bind(this);

    this.yesButtonOnClick = this.yesButtonOnClick.bind(this);
    this.noButtonOnClick = this.noButtonOnClick.bind(this);
  }

  handleClose = () => this.setState({ show: false, saving: false });
  handleShow = () => this.setState({ show: true });

  yesButtonOnClick(event) {
    if (this.props.validation) {
      if (!this.props.validation()) {
        return;
      }
    }

    if (this.props.yesButtonOnClick) {
      this.props
        .yesButtonOnClick(event)
        .then(() => {
          this.setState({
            yesButtonCompletedStatus: true,
            yesButtonCompletedToastTime: new Date(Date.now()).toLocaleTimeString("en-US"),
            showYesButtonCompletedToast: true,
          });
          if (this.props.onSuccess) {
            this.props.onSuccess();
          }
        })
        .catch(() => {
          this.setState({
            yesButtonCompletedStatus: false,
            yesButtonCompletedToastTime: new Date(Date.now()).toLocaleTimeString("en-US"),
            showYesButtonCompletedToast: true,
          });
        });
      this.setState({
        yesButtonToastTime: new Date(Date.now()).toLocaleTimeString("en-US"),
        showYesButtonToast: true,
      });
      this.handleClose();
    } else this.handleClose();
  }

  noButtonOnClick() {
    if (this.props.noButtonOnClick) this.props.noButtonOnClick().then(() => this.handleClose());
    else this.handleClose();
  }
}

RevShareModal.propTypes = {
  api: PropTypes.string,
  buttonSize: PropTypes.string,
  buttonStyle: PropTypes.object,
  buttonText: PropTypes.string,
  buttonVariant: PropTypes.string,
  hideYesButton: PropTypes.bool,
  modalSize: PropTypes.string,
  noButtonOnClick: PropTypes.func,
  noButtonText: PropTypes.string,
  noButtonVariant: PropTypes.string,
  onSuccess: PropTypes.func,
  saving: PropTypes.bool,
  title: PropTypes.string.isRequired,
  validation: PropTypes.func,
  yesButtonOnClick: PropTypes.func,
  yesButtonText: PropTypes.string,
  yesButtonVariant: PropTypes.string,
};
